import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { NavLink } from 'react-router-dom';
import './css/Navbar.css';
import Logo from './images/logoimg.jpeg';
const Navbar = () => {
    return (
            <nav className="navbar">
                <div className='navbar_logo'>
                    <img classname='navba_logo__img' src={Logo} style={{height: "5rem"}} alt="" />
                </div>
                
                <ul className="navbar_icons">
                    <li className='navbar_icons__li'>
                        <NavLink to="/">Home</NavLink>
                    </li>
                    <li className='navbar_icons__li'>
                        <NavLink to="/product_list">Product</NavLink>
                    </li>
                    <li className='navbar_icons__li'>
                        <NavLink to="/download">Download</NavLink>
                    </li>
                    <li className='navbar_icons__li'>
                        <NavLink to="/connect">Connect</NavLink>
                    </li>
                    <li className='navbar_icons__li'>
                        <NavLink to="/#">Order</NavLink>
                    </li>

                </ul>
            </nav>
    )
}

export default Navbar;